<h3 mat-dialog-title class="title">
  {{ 'boss.pos.priceLevelsModal.title' | translate }}
</h3>

<mat-dialog-content>
    <div class="messages">
      <txp-message [type]="messageType.DANGER"
                   data-qa-label="showError"
                   *ngIf="showError">
        {{ 'boss.pos.priceLevelsModal.errorMessage' | translate }}
      </txp-message>
    </div>
    <h4 class="sub-title">
      {{ data.item.name }}
    </h4>
    <div class="content">
      <strong>
        Price Level
      </strong>
      <strong>
        Price
      </strong>

      <div class="level-label">
        Default
      </div>

      <mat-form-field [formGroup]="form">
        <mat-label>
          {{ 'boss.pos.priceLevelsModal.defaultPrice' | translate }}
        </mat-label>
        <input matInput
               required
               txpNumbersOnly
               formControlName="price">
        <mat-error>
          {{ 'form.error.required' | translate}}
        </mat-error>
      </mat-form-field>

      <ng-container *ngFor="let level of priceLevels">
        <div class="level-label">
          {{ level }}
        </div>

        <mat-form-field [formGroup]="$any(form.get('priceLevels'))">
          <mat-label>
            {{ 'boss.pos.priceLevelsModal.level' | translate:{ nr: level } }}
          </mat-label>
          <input matInput
                 txpNumbersOnly
                 [formControlName]="level">
          <mat-error>
            {{ 'form.error.required' | translate}}
          </mat-error>
        </mat-form-field>
      </ng-container>
    </div>
</mat-dialog-content>
<mat-dialog-actions>
    <txp-button [style]="buttonStyle.SECONDARY"
                [disabled]="isLoading"
                data-qa-label="CancelButton"
                (click)="handleCancel()">
      {{ 'form.button.cancel' | translate }}
    </txp-button>
    <txp-button [style]="buttonStyle.PRIMARY"
                [loading]="isLoading"
                data-qa-label="DoneButton"
                (click)="handleDone()">
      {{ 'form.button.done' | translate }}
    </txp-button>
</mat-dialog-actions>
